import React from "react";
import { useDispatch } from "react-redux";
import Box from "../../../../components/Box";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { FastFirmFields } from "../../../../components/FastFirm";
import { Helpers } from "../../../../helpers/Helpers";
import { GetCompanyByIdResponse, GetCompanyByIdResponseCompanyAuthorizedPerson } from "../../../../models/response/company/GetCompanyByIdResponse";
import { storeActivityIndicator, storeFastFirm } from "../../../../redux/reducers/authSlice";
import { CompanyService } from "../../../../services/CompanyService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";
import CustomDatePicker from "../../../../components/CustomDatePicker";
import CustomTextInput from "../../../../components/CustomTextInput";
import { ConstantService } from "../../../../services/ConstantService";


interface Props {
    generalInformationRef: any
    selectedCurrentCompany: CustomSingleSelectModel | undefined
    setSelectedCurrentCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setCompanyAuthorizedPersons: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyAuthorizedPerson[]>>
    authorizedPersonSelectHandler: (_selectedAuthorizedPerson: CustomSingleSelectModel | undefined, _list?: GetCompanyByIdResponseCompanyAuthorizedPerson[] | undefined, phoneToBeSet?: string | undefined, emailToBeSet?: string | undefined) => void
    setSelectedAuthorizedPerson: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setPhoneList: React.Dispatch<React.SetStateAction<CustomSingleSelectModel[]>>
    setSelectedPhone: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setEmailList: React.Dispatch<React.SetStateAction<CustomSingleSelectModel[]>>
    setSelectedEmail: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedAuthorizedPerson: CustomSingleSelectModel | undefined
    companyAuthorizedPersons: GetCompanyByIdResponseCompanyAuthorizedPerson[]
    selectedPhone: CustomSingleSelectModel | undefined
    startDate: string | undefined
    setStartDate: React.Dispatch<React.SetStateAction<string | undefined>>
    endDate: string | undefined
    setEndDate: React.Dispatch<React.SetStateAction<string | undefined>>
    phoneList: CustomSingleSelectModel[]
    selectedEmail: CustomSingleSelectModel | undefined
    emailList: CustomSingleSelectModel[]
    isDisabled: boolean
    isPartialDisabled: boolean
    refNo: string | undefined
    setRefNo: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedOfferStatus: CustomSingleSelectModel | undefined
    setSelectedOfferStatus: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
}

const GeneralInformation = ({
    generalInformationRef,
    selectedCurrentCompany,
    setSelectedCurrentCompany,
    setCompanyAuthorizedPersons,
    authorizedPersonSelectHandler,
    setSelectedAuthorizedPerson,
    setPhoneList,
    setSelectedPhone,
    setEmailList,
    setSelectedEmail,
    selectedAuthorizedPerson,
    companyAuthorizedPersons,
    selectedPhone,
    endDate,
    setEndDate,
    setStartDate,
    startDate,
    phoneList,
    emailList,
    selectedEmail,
    isDisabled,
    isPartialDisabled,
    refNo,
    selectedOfferStatus,
    setRefNo,
    setSelectedOfferStatus
}: Props) => {
    const dispatch = useDispatch();

    const companySelectedHandler = async (_companyId: string | undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            if (_companyId && !Helpers.isEmpty(_companyId)) {
                var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(_companyId);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setCompanyAuthorizedPersons(response.data.companyAuthorizedPersons);

                if (response.data.companyAuthorizedPersons.length == 1) {
                    var firstOne = response.data.companyAuthorizedPersons[0];
                    authorizedPersonSelectHandler({ label: firstOne.name + ' ' + firstOne.surname, value: firstOne.companyAuthorizedPersonId }, response.data.companyAuthorizedPersons);
                    return;
                }
            }
            else {
                setCompanyAuthorizedPersons([]);
            }

            setSelectedAuthorizedPerson(undefined);
            setPhoneList([]);
            setSelectedPhone(undefined);
            setEmailList([]);
            setSelectedEmail(undefined);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }


    return (
        <div className='containerPart' ref={generalInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Ref No</label>
                            <CustomTextInput isDisabled value={refNo} setValue={setRefNo} />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Teklif Durumu</label>
                            <CustomSingleSelect
                                disabled={isDisabled}
                                selectedValue={selectedOfferStatus}
                                onChange={setSelectedOfferStatus}
                                onMenuOpen={() => ConstantService.getConstantList('OFFER_STATUS')}
                                labelName='value'
                                valueName='constantId'
                                additionalValue1Name="additionalValue1"
                            />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Müşteri</label>

                            <CustomSingleSelect
                                disabled={isPartialDisabled || isDisabled}
                                selectedValue={selectedCurrentCompany}
                                onChange={(selectedValue) => {
                                    setSelectedCurrentCompany(selectedValue);
                                    companySelectedHandler(selectedValue?.value);
                                }}
                                insertable={{
                                    tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                    onClick: () => {
                                        dispatch(storeFastFirm({
                                            companyId: selectedCurrentCompany?.value,
                                            isCustomer: true,
                                            isAgency: true,
                                            isSupplier: true,
                                            allowedFields: [FastFirmFields.FirmName, FastFirmFields.AuthorizedPerson],
                                            onSubmit: async (response) => {
                                                setSelectedCurrentCompany({ label: response.name, value: response.companyId })
                                                companySelectedHandler(response.companyId);
                                            },
                                            defaultInitialCompanyTypeId: '1'
                                        }))
                                    }
                                }}
                                onMenuOpen={[
                                    () => CompanyService.getCompanyList({ isCustomer: true }),
                                ]}
                                labelName='name'
                                valueName='companyId'
                            />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Yetkili Telefon</label>

                            <CustomSingleSelect
                                disabled={isPartialDisabled || isDisabled}
                                selectedValue={selectedPhone}
                                onChange={setSelectedPhone}
                                onMenuOpen={async () => {
                                    return {
                                        isSuccess: true,
                                        data: phoneList
                                    }
                                }}
                                labelName='label'
                                valueName='value'
                            />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Başlangıç Tarihi</label>
                            <CustomDatePicker isDisabled={isPartialDisabled || isDisabled} value={startDate} setValue={setStartDate} />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Yetkili Kişi</label>

                            <CustomSingleSelect
                                disabled={isPartialDisabled || isDisabled}
                                selectedValue={selectedAuthorizedPerson}
                                onChange={authorizedPersonSelectHandler}
                                onMenuOpen={async () => {
                                    return {
                                        isSuccess: true,
                                        data: companyAuthorizedPersons.map(function (x) {
                                            return { label: x.name + ' ' + x.surname, value: x.companyAuthorizedPersonId }
                                        })
                                    }
                                }}
                                labelName='label'
                                valueName='value'
                            />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Yetkili E-Posta</label>

                            <CustomSingleSelect
                                disabled={isPartialDisabled || isDisabled}
                                selectedValue={selectedEmail}
                                onChange={setSelectedEmail}
                                onMenuOpen={async () => {
                                    return {
                                        isSuccess: true,
                                        data: emailList
                                    }
                                }}
                                labelName='label'
                                valueName='value'
                            />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Bitiş Tarihi</label>
                            <CustomDatePicker isDisabled={isDisabled} value={endDate} setValue={setEndDate} />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation;